




























































































import {Component, Mixins} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import CDatepicker from '@/components/base/datepicker/CDatepicker.vue';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
import CTextField from '@/components/base/textField/CTextField.vue';
import CSelect from '@/components/base/select/CSelect.vue';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
import CCheckbox from '@/components/base/checkbox/CCheckbox.vue';
import CVolumeField from '@/components/base/volumeField/CVolumeField.vue';
@Component({
    components: {CVolumeField, CCheckbox, CNumberField, CSelect, CTextField, CEditDialog, CDatepicker},
})
export default class OrderEditDialog extends Mixins(EditDialogMixin) {
    errorKeyList = {
        IdOrderPriority: 'IdOrderPriority',
        IdPlywoodGrade: 'IdPlywoodGrade',
        IdPlywoodSize: 'IdPlywoodSize',
        IdPlywoodSpecie: 'IdPlywoodSpecie',
        IdPlywoodSurface: 'IdPlywoodSurface',
        IdPlywoodThickness: 'IdPlywoodThickness',
    };
    get regexpRules() {
        return [
            (v: any) =>
                /(^[А-ЯЁа-яёЁA-Za-z0-9/(/)""/%№+-]+[А-ЯЁа-яёЁA-Za-z0-9/(/)""\s/%№+-]*$|^$)/.test(v) ||
                this.$t('Common.Messages.AlphaNumericExpression'),
        ];
    }
}
